import { __awaiter } from "tslib";
import services from '@/services/index';
const stepByStepState = {};
export default function stepByStepValidate(payload) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        if (!payload.name)
            throw new Error('Method name required');
        if (!payload.endpointName)
            throw new Error('Endpoint name required');
        if (!payload.data)
            throw new Error('Data required');
        if (payload.steps) {
            stepByStepState[payload.name] = {
                step: 1,
                steps: payload.steps
            };
        }
        // @ts-ignore
        const response = yield services.mainService[payload.endpointName](payload.data);
        if (response.success) {
            if (payload.reset) {
                if (stepByStepState[payload.name])
                    stepByStepState[payload.name].step = 1;
            }
            else {
                if (((_a = stepByStepState[payload.name]) === null || _a === void 0 ? void 0 : _a.step) === stepByStepState[payload.name].steps) {
                    stepByStepState[payload.name].step = 1;
                }
                else
                    stepByStepState[payload.name].step += 1;
            }
            return {
                success: true,
                data: response.data
            };
        }
        else {
            return {
                success: false,
                errors: (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.errors) !== null && _c !== void 0 ? _c : ['Не удалось выполнить операцию, попробуйте снова']
            };
        }
    });
}
